import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/apiClient";
import { Bot, ArrowLeft, Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";

function renderMarkdown(md) {
  const lines = (md || "").split("\n");
  const out = [];
  let list = [];
  const flush = (key) => {
    if (list.length) {
      out.push(<ul key={`ul-${key}`} className="list-disc pl-6 space-y-1.5 my-3 text-muted-foreground">{list}</ul>);
      list = [];
    }
  };
  const inline = (t) =>
    t.split(/(\*\*[^*]+\*\*)/g).map((p, i) =>
      p.startsWith("**") && p.endsWith("**")
        ? <strong key={i} className="text-foreground font-semibold">{p.slice(2, -2)}</strong>
        : <React.Fragment key={i}>{p.replace(/^_|_$/g, "")}</React.Fragment>
    );
  lines.forEach((raw, idx) => {
    const line = raw.trimEnd();
    if (line.startsWith("### ")) { flush(idx); out.push(<h3 key={idx} className="font-display text-lg tracking-wide mt-6 mb-2">{line.slice(4)}</h3>); }
    else if (line.startsWith("## ")) { flush(idx); out.push(<h2 key={idx} className="font-display text-2xl tracking-tight mt-8 mb-3 text-primary">{line.slice(3)}</h2>); }
    else if (line.startsWith("# ")) { flush(idx); out.push(<h1 key={idx} className="font-display text-3xl md:text-4xl tracking-tight mb-2">{line.slice(2)}</h1>); }
    else if (line.startsWith("- ")) { list.push(<li key={idx}>{inline(line.slice(2))}</li>); }
    else if (line.trim() === "") { flush(idx); }
    else { flush(idx); out.push(<p key={idx} className="text-muted-foreground leading-relaxed my-2">{inline(line)}</p>); }
  });
  flush("end");
  return out;
}

export default function Terms() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => { api.get("/terms").then((r) => setData(r.data)).catch(() => setData({ content: "Terms unavailable." })); }, []);

  return (
    <div className="min-h-screen bg-background text-foreground grain" data-testid="terms-page">
      <nav className="flex items-center justify-between px-6 md:px-12 py-5 border-b border-white/10 bg-[#0a0a0a] sticky top-0 z-50" style={{ paddingTop: "calc(1.25rem + env(safe-area-inset-top))" }}>
        <div className="flex items-center gap-2.5">
          <div className="h-9 w-9 bg-primary rounded-sm flex items-center justify-center"><Bot className="h-5 w-5 text-white" /></div>
          <span className="font-display text-2xl tracking-wide">TRADIE<span className="text-primary">DESK</span></span>
        </div>
        <Button data-testid="terms-back-btn" variant="ghost" onClick={() => navigate(-1)} className="rounded-sm gap-2 text-foreground hover:text-primary hover:bg-secondary">
          <ArrowLeft className="h-4 w-4" /> Back
        </Button>
      </nav>
      <div className="max-w-3xl mx-auto px-6 md:px-8 py-12">
        {!data ? (
          <div className="flex justify-center py-20"><Loader2 className="h-6 w-6 animate-spin text-primary" /></div>
        ) : (
          <div className="bg-[#18181b] border border-white/10 rounded-sm p-6 md:p-10">{renderMarkdown(data.content)}</div>
        )}
      </div>
    </div>
  );
}
